/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect } from "react";
import { withRouter } from "react-router-dom";
import { observer } from "mobx-react";
import { userDetail } from "Stores/userDetail";
import Utils from "Utils/utils";
import { toasterState } from "Components/common/toaster";
import { URLS, makeApi } from "Utils/apiURL";
import { MP_EVENT } from "Static/constant";
import SequenceTemplateData from "Stores/sequence/SequenceTemplateData";
import Button from "Components/common/Button";
import StagesCard from "./StagesCard";
import { upgradePopupState } from "Components/Paywall/UpgradePopup";
import SequenceUtils from "Utils/SequenceUtils";
import TitleBadge from "./TitleBadge";
import { seqTemplatePopupState } from "./SeqTemplatePopupState";
import { linkedInTemplatePopupState } from "../LinkedInTemplatePopupState";
import PaywallUtils from "Utils/PaywallUtils";
import { sequenceStoreData } from "Stores/sequenceData";

const ActionButtons = observer(props => {
  const { loader = false, action = () => {} } = props;
  const backBtnObj = {
    id: "backBtn",
    name: "backBtn",
    btnText: "Back",
    icon: false,
    iconName: "",
    type: "button",
    className: "backBtn",
    click: () => {
      SequenceTemplateData.setSeqTemmplateClicked(false);
      seqTemplatePopupState.setProgressBarState(1);
    }
  };

  const createAndCustomizeBtnObj = {
    id: "createCustomizeSeqBtn",
    name: "createCustomizeSeqBtn",
    btnText: linkedInTemplatePopupState.targetSequenceId ? "Use Template" : "Create And Customize",
    icon: false,
    iconName: "",
    type: "button",
    className: loader ? "loading" : "",
    loader: loader,
    click: () => action()
  };

  return (
    <div className="btnSection">
      <Button {...backBtnObj} />
      <Button {...createAndCustomizeBtnObj} />
    </div>
  );
});

const TemplateSelectedStages = (props) => {
  const { close, isSidePanel = false } = props || {};
  const userData = userDetail?.userFeatureFlag || {};
  const { inFreePlan = false, planName = "" } = userDetail?.userFeatureFlag || {};
  
  const selectedTemplate = SequenceTemplateData.selectedPredefinedTemplate;
  const [loader, setLoader] = useState(false);

  const getSeqTotalDays = (steps) => {
    let totalDays = 0;
    if (steps) {
      for (const [key, value] of Object.entries(steps)) {
        totalDays += value.daysLater || 0;
      }
    }
    return totalDays;
  };

  const seqName = selectedTemplate?.name || "";
  const stagesLen = selectedTemplate?.steps ? Object.keys(selectedTemplate.steps).length : 0;
  const totalDays = getSeqTotalDays(selectedTemplate?.steps);

  const constructPayload = () => {
    if (selectedTemplate && Object.keys(selectedTemplate).length > 0) {
      const clonedTemplate = JSON.parse(JSON.stringify(selectedTemplate));
      delete clonedTemplate.id;
      delete clonedTemplate._id;
      delete clonedTemplate.memberId;
      const folderDetailsObj = Utils.getFolderDetails();
      const folderName = folderDetailsObj.folderName;
      const folderId = folderDetailsObj.folderId;
      clonedTemplate.folderName = folderName || null;
      clonedTemplate.folderId = folderId || null;
      const tempStages = clonedTemplate.steps;
      for (let key in tempStages) {
        tempStages[key].uniqueId = key;
      }
      clonedTemplate.steps = tempStages;
      const greatestUniqueId = Math.max.apply(
        Math,
        Utils.convertObjectToArray(tempStages).map(function (item) {
          return item.uniqueId;
        })
      );
      clonedTemplate.greatestUniqueId = greatestUniqueId;
      return clonedTemplate;
    }
    return selectedTemplate;
  };

  const createCustomizeSeqAndNavToOverview = async () => {
    const eligibleCount = SequenceUtils.checkEligibleSequenceCount();
    const isStagesHasTask = SequenceUtils.hasTask(selectedTemplate?.steps);
    if (
      eligibleCount &&
      ((isStagesHasTask && userData?.taskEnabled) || !isStagesHasTask)
    ) {
      try {
        if (selectedTemplate && Object.keys(selectedTemplate).length > 0) {
          setLoader(true);
          const config = {
            url: URLS.updateSequence,
            method: "POST",
            data: constructPayload()
          };
          let res = await makeApi(config);
          let resData = [];
          resData.push(res?.data);
          let finalData = SequenceUtils.getProccessedResponseData(resData);
          if (finalData?.length) {
            sequenceStoreData.setSelectedTemplateSequence(finalData);
          }
          SequenceTemplateData.setSeqTemmplateClicked(false);
          seqTemplatePopupState.setProgressBarState(1);
          if (res?.data?.id) {
            Utils.mixpanelTrack(MP_EVENT.SQ_CREATED, {
              sequenceName: seqName,
              sequenceType: "Template",
              pageType: "Sequence Page"
            });
            setLoader(false);
            userData.noOfSequencesUsed += 1;
            userDetail.setUserFeatureFlag(userData);
            toasterState.setToastMsg(
              "Sequence created successfully",
              "success"
            );
            close();
            Utils.getOnboardingData();
            const navFolderId = res?.data?.folderId || "all";
            props.history.push(`/sequences/${navFolderId}/${res.data.id}`);
          } else if (res.response.status === 426) {
            setLoader(false);
            close();
            Utils.showUpgradePopup("sequences", true, true);
          } else if (res.response.status === 460) {
            setLoader(false);
            toasterState.setToastMsg(
              "Spintax is not allowed inside conditional blocks",
              "failure"
            );
          } else {
            setLoader(false);
          }
        }
      } catch (e) {
        setLoader(false);
        close();
        console.error(
          "Getting error on create predefined template sequence",
          e
        );
      }
    } else {
      setLoader(false);
      close();
      PaywallUtils.upgradeUtilsFunction(
        "newSequenceWithTask",
        true,
        planName,
        inFreePlan
      );
    }
  };

  useEffect(() => {
    if (isSidePanel && props.setCreateAction) {
      props.setCreateAction(() => createCustomizeSeqAndNavToOverview);
    }
  }, [selectedTemplate, loader]);

  return (
    <div className={`sequenceStagesSection ${isSidePanel ? "sidePanel" : ""}`}>
      {selectedTemplate && (
        <>
          {!isSidePanel && (
            <TitleBadge title={seqName} showDesc={true}>
              <div className="seqStepsDaysWrapper">
                <span className="totalStages">{stagesLen} total steps</span>{" "}
                <span className="totalDays">{totalDays} days in sequence</span>
              </div>
            </TitleBadge>
          )}
          {isSidePanel && (
            <div className="previewHeader">
              <h3 className="previewTitle">{seqName}</h3>
              <div className="seqStepsDaysWrapper">
                <span className="totalStages">{stagesLen} steps</span>
                <span className="divider">•</span>
                <span className="totalDays">{totalDays} days</span>
              </div>
            </div>
          )}
          <StagesCard />
          {!isSidePanel && (
            <ActionButtons
              loader={loader}
              action={createCustomizeSeqAndNavToOverview}
            />
          )}
        </>
      )}
    </div>
  );
};

export default withRouter(observer(TemplateSelectedStages));
export { TemplateSelectedStages };
